import { render, staticRenderFns } from "./JFormDemo.vue?vue&type=template&id=560c1bca"
import script from "./JFormDemo.vue?vue&type=script&lang=js"
export * from "./JFormDemo.vue?vue&type=script&lang=js"
import style0 from "./JFormDemo.vue?vue&type=style&index=0&id=560c1bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports